import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-slate-50 py-12 md:py-16 px-4" data-id="element-222">
      <div className="max-w-3xl mx-auto" data-id="element-223">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-4 border-green-500 rounded-xl p-8 md:p-12 text-center shadow-xl" data-id="element-224">
          <Shield className="w-16 h-16 text-green-600 mx-auto mb-6" data-id="element-225" />
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6" data-id="element-226">
            🛡️ GARANTÍA RESCATE ACADÉMICO™ — 7 DÍAS
          </h3>
          <p className="text-lg text-slate-700 leading-relaxed mb-4" data-id="element-227">
            Revisá el material tranquilo durante 7 días.
          </p>
          <p className="text-xl font-semibold text-slate-900 mb-4" data-id="element-228">
            Si no te sirve, te devolvemos el 100%.
          </p>
          <p className="text-lg text-slate-700 mb-6" data-id="element-229">
            Sin vueltas. Sin drama. Sin preguntas.
          </p>
          <p className="text-slate-600 font-medium" data-id="element-230">
            Más de 500 estudiantes ya confiaron en este sistema.
          </p>
        </motion.div>
      </div>
    </section>;
}